import type { TenantConfig } from '@/types/TenantConfig'

export const ticketkite: TenantConfig = {
  logo: 'assets/ticketkite/static/logo.png',
  teaserImageSize: {
    width: 320,
    height: 240,
  },
  themeOptions: {
    primaryColor: '#CC0065',
    secondaryColor: '#CC0065',
    headerBackground: 'white',
    footerBackgroundColor: '#222222',
    footerTextColor: 'white',
    logoHeight: '35px',
    headerTopBorder: '4px solid #CC0065',
    headerBottomBorder: '1px solid #dde0e4',
    headerHeight: '90px',
  },
  componentOptions: {
    stripeCreditCard: {
      fontFaceStylesheet: 'https://use.typekit.net/tsu4pxd.css',
    },
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/ticketkite/static/completed.jpeg',
      },
      completedContentOffset: {
        desktop: '-200px',
        mobile: '-150px',
      },
    },
  },
}
